
















































































































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { Comment, PaymentType } from '@/types';
import { userService } from '@/services/user.services';
import { claimService } from '@/services/claim.services';
import { Action, Getter } from 'vuex-class';
import { User } from '@/stores/authentication/types';

@Component
export default class NewCommentModal extends Vue {
    @Action('getUsers', { namespace: 'dashboard' }) getUsers: any;
    @Getter('users', { namespace: 'dashboard' }) getUsersData!: User[];
    @Prop() readonly attachment!: boolean;
    @Prop() readonly amount!: boolean;
    @Prop() readonly reminder!: boolean;
    @Prop() readonly assignee!: boolean;
    @Prop() readonly date!: boolean;
    @Prop({ default: 'New Comment'}) readonly title!: string;
    @Prop({
        default: {
            comment: '',
            assignee: undefined,
        },
    }) readonly comment!: Comment;

    commentData: Comment = Object.assign({}, this.comment);
    titleData: string = this.title;

    assignees: any = [];
    paymentTypes: PaymentType[] = [];

    @Watch('commentData.assignee')
    updateIds() {
        this.commentData.assignee_id = this.commentData.assignee && this.commentData.assignee.id;
    }

    @Watch('commentData.payment_type')
    updatePaymentTypes() {
        this.commentData.payment_type_id = this.commentData.payment_type && this.commentData.payment_type.id;
    }

    mounted() {
        userService.select()
        .then((result) => {
            this.assignees = result.data.data;
        });


        claimService.getPaymentTypes()
        .then((result) => {
            this.paymentTypes = result.data.data.map((val: any) => {
                return {
                    value: val.id,
                    text: val.name,
                };
            });
        });
        this.getUsers();
    }

    formatNames(files: any) {
        if (files.length === 1) {
          return files[0].name;
        } else {
          return `${files.length} files selected`;
        }
    }

    showModal() {
        this.commentData = Object.assign({}, this.comment);
        if (typeof this.commentData.amount === 'string') {
            this.commentData.amount = parseFloat(this.commentData.amount);
        }
        if (this.commentData.id) {
            this.titleData = 'Edit Comment';
        } else {
            this.titleData = 'New Comment';
            this.commentData.date = new Date();
        }
        (this.$refs.modal as any).show();
    }

    saveModal() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                (this.$refs.modal as any).hide();
                this.save();
            }
        });
    }

    @Emit()
    save() {
        return this.commentData;
    }

    validateField(name: string) {
        if (this.veeFields[name] && (this.veeFields[name].dirty || this.veeFields[name].validated)) {
          return !this.errors.has(name);
        }
        return null;
    }

    searchAssignee(search: string, loading: any) {
        loading(true);
        userService.select(search)
        .then((result) => {
            this.assignees = result.data.data;
            loading(false);
        });
    }

    get users() {
        return this.getUsersData && this.getUsersData.map((val) => {
            return {
                value: val,
                text: val.name,
            };
        });
    }
}
